// extracted by mini-css-extract-plugin
module.exports = {"root":"AgreementModal_root__3Cy6Z","additionalInfo":"AgreementModal_additionalInfo__3zfvs"};